import Type from "../../Types";
import { serviceGetProjects } from "../../../api/services/project";
import { showToast } from "../../Utility";

export function getProjects({ userData, setProjects, onSuccess, onError }) {
  const formData = new FormData();
  formData.append("username", userData.user.username);

  serviceGetProjects(formData, userData.token)
    .then((res) => {
      if (res.data && res.data.status === "success") {
        setProjects(res.data.projects);
        if (typeof onError == "function") onSuccess();
      }
    })
    .catch((err) => {
      showToast(err.message, Type.NOTIFICATION.WARNING);
      if (typeof onError == "function") onError();
    });
}
